import { cn } from '@repo/ui';
import type { ReactElement, ReactNode } from 'react';

interface PageHeaderProps {
  readonly title: string;
  readonly description?: ReactNode;
  /** 오른쪽 주요 동작(예: "신규 등록" 버튼). */
  readonly actions?: ReactNode;
  readonly className?: string;
}

/** 관리자 화면 머리말 — 큰 제목(h1)·한 줄 설명·오른쪽 주요 동작. 모든 화면이 같은 자리에 같은 크기로 쓴다. */
export const PageHeader = ({
  title,
  description,
  actions,
  className,
}: PageHeaderProps): ReactElement => (
  <div className={cn('mb-8 flex flex-wrap items-end justify-between gap-4', className)}>
    <div className="min-w-0">
      <h1 className="text-[28px] leading-tight font-bold tracking-[-0.02em]">{title}</h1>
      {/* 설명은 글 한 줄이거나 배지 목록 같은 블록이다 — <p> 안에는 목록을 둘 수 없어 div 로 감싼다(모양은 같다). */}
      {description ? (
        <div className="mt-1.5 text-sm text-muted-foreground">{description}</div>
      ) : null}
    </div>
    {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
  </div>
);
